import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Issue #1150 (D349) — has the player just arrived from a saved "How did it go?"
 * (`PerformanceTracking` navigates to Plan with `state.addedMatch`)? Read once
 * on mount into state, and the entry's router state is cleared with a replace, so
 * the board's "Added to your record" pill is shown once: a reload or Back does not
 * repeat it. Lives in the PAGE (`DevelopmentPlan`), which stays mounted when
 * Coming up is swapped for the create-a-plan screen; `PlanComingUp` remounts then
 * and would lose it.
 */
export function useAddedMatch() {
  const navigate = useNavigate();
  const location = useLocation();
  // The finished match `{ id, opponent }`, or null: the pill's "Add a reflection" (D360) needs its id.
  const [added] = useState(() => location?.state?.addedMatch || null);
  useEffect(() => {
    if (location?.state?.addedMatch) navigate(`${location.pathname}${location.search || ""}`, { replace: true, state: null });
    // Mount-only: a one-time clear.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Kept here, with the match, so a remount of Coming up never brings the link back over a saved
  // reflection (a second save would overwrite it).
  const [reflected, setReflected] = useState(false);
  const markReflected = useCallback(() => setReflected(true), []);
  return added ? { ...added, reflected, markReflected } : null;
}

/** Whether the pill shows (a boolean; the match itself is `useAddedMatch`). */
export function useAddedMatchNotice() {
  return Boolean(useAddedMatch());
}

export default useAddedMatchNotice;
